<template>
  <div>
    <navbar></navbar>
    <!-- <main class="py-4"> -->
    <main class="content-main">
      <router-view></router-view>
    </main>
    <!-- <Question :qData="question" :qID="1"></Question> -->
  </div>
</template>

<script>
import navbar from "./components/Navbar";
// import Question from './components/Question'
// import Section from './components/Section'
export default {
  components: {
    navbar
    // Question
    // Section
  },
  methods: {
    handleNextSection(data) {
      console.log("notified")
    }
  },
  // data: function() {
	// 	return {
      
  //   }
  // }
};
</script>

<style>
html {
  min-height: 100vh;
  width: 100vw;
  background-color: #eff2f6 !important;
  overflow-x: hidden !important;
}

body {
  overflow-x: hidden !important;
}

/* h1 {
  font-size: 50px !important;

} */

p {
    margin-top: 20px;
    font-size: 20px !important;
}

a, li {
  font-size: 20px !important;
}

/* .card {
  padding: 40px;
} */

.content-main {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: flex-start; */
  background-color: #eff2f6 !important;
  padding-top: 10vh;
  /* height: 90vh; */
}


</style>